import React from 'react';
import { Link } from 'gatsby';

export default function Nav({ onClose = () => {} }) {
  return (
    <nav id="menu">
      <div className="inner">
        <ul>
          <li>
            <Link to="/">AMG Distribution</Link>
          </li>
          <li>
            <Link to="/catalog/aeg/catalog">AEG</Link>
          </li>
          <li>
            <Link to="/catalog/cmo/catalog">ЦМО</Link>
          </li>
          <li>
            <Link to="/catalog/yatagan/catalog">Ятаган</Link>
          </li>
          <li className="shop">
            <Link to="//distribution.amgcorporation.de/shop">Интернет магазин</Link>
          </li>
        </ul>
      </div>
      <a
        className="close"
        onClick={e => {
          e.preventDefault();
          onClose();
        }}
        href="#menu"
      >

      </a>
    </nav>
  );
}
